(() => {
  if (window.CampanaFrierenLista) return;
  window.CampanaFrierenLista = true;

  const reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function iniciarApariciones() {
    document.querySelectorAll('.fr-aparece:not([data-listo])').forEach((elemento) => {
      elemento.dataset.listo = '1';
      if (reducirMovimiento || !('IntersectionObserver' in window)) {
        elemento.classList.add('es-visible');
        return;
      }
      const observador = new IntersectionObserver((entradas) => {
        if (entradas[0].isIntersecting) {
          elemento.classList.add('es-visible');
          observador.disconnect();
        }
      }, { threshold: 0.14 });
      observador.observe(elemento);
    });
  }

  function iniciarParallax() {
    if (reducirMovimiento) return;
    document.querySelectorAll('[data-fr-parallax]:not([data-parallax-listo])').forEach((area) => {
      area.dataset.parallaxListo = '1';
      area.addEventListener('pointermove', (evento) => {
        const limites = area.getBoundingClientRect();
        const x = (evento.clientX - limites.left) / limites.width - 0.5;
        const y = (evento.clientY - limites.top) / limites.height - 0.5;
        area.querySelectorAll('[data-profundidad]').forEach((capa) => {
          const profundidad = Number(capa.dataset.profundidad);
          capa.style.transform = `translate3d(${x * profundidad}px,${y * profundidad}px,0)`;
        });
      }, { passive: true });
      area.addEventListener('pointerleave', () => {
        area.querySelectorAll('[data-profundidad]').forEach((capa) => { capa.style.transform = ''; });
      });
    });
  }

  function iniciarRuedas() {
    document.querySelectorAll('[data-fr-rueda]:not([data-rueda-lista])').forEach((rueda) => {
      rueda.dataset.ruedaLista = '1';
      const elementos = Array.from(rueda.querySelectorAll('[data-fr-rueda-item]'));
      const puntos = Array.from(rueda.querySelectorAll('[data-fr-rueda-punto]'));
      const anterior = rueda.querySelector('[data-fr-rueda-anterior]');
      const siguiente = rueda.querySelector('[data-fr-rueda-siguiente]');
      if (!elementos.length) return;

      let indice = 0;
      let temporizador;
      let toqueX = 0;
      let toqueY = 0;
      const intervalo = Math.max(3000, Number(rueda.dataset.intervalo) || 5000);
      const rotacionAutomatica = rueda.dataset.autoplay !== 'false';

      function actualizar(nuevoIndice) {
        indice = (nuevoIndice + elementos.length) % elementos.length;
        elementos.forEach((elemento, posicion) => {
          const distancia = (posicion - indice + elementos.length) % elementos.length;
          elemento.classList.remove('es-anterior', 'es-activo', 'es-siguiente', 'es-oculto');
          if (distancia === 0) elemento.classList.add('es-activo');
          else if (distancia === 1) elemento.classList.add('es-siguiente');
          else if (distancia === elementos.length - 1) elemento.classList.add('es-anterior');
          else elemento.classList.add('es-oculto');
          elemento.setAttribute('aria-hidden', distancia === 0 ? 'false' : 'true');
        });
        puntos.forEach((punto, posicion) => {
          const activo = posicion === indice;
          punto.classList.toggle('es-activo', activo);
          punto.setAttribute('aria-current', activo ? 'true' : 'false');
        });
      }

      function detener() {
        if (temporizador) window.clearInterval(temporizador);
      }

      function reproducir() {
        detener();
        if (rotacionAutomatica && !reducirMovimiento && elementos.length > 1) {
          temporizador = window.setInterval(() => actualizar(indice + 1), intervalo);
        }
      }

      anterior?.addEventListener('click', () => { actualizar(indice - 1); reproducir(); });
      siguiente?.addEventListener('click', () => { actualizar(indice + 1); reproducir(); });
      puntos.forEach((punto) => punto.addEventListener('click', () => {
        actualizar(Number(punto.dataset.frRuedaPunto));
        reproducir();
      }));
      rueda.addEventListener('mouseenter', detener);
      rueda.addEventListener('mouseleave', reproducir);
      rueda.addEventListener('focusin', detener);
      rueda.addEventListener('focusout', reproducir);
      rueda.addEventListener('touchstart', (evento) => {
        toqueX = evento.changedTouches[0].clientX;
        toqueY = evento.changedTouches[0].clientY;
        detener();
      }, { passive: true });
      rueda.addEventListener('touchend', (evento) => {
        const desplazamientoX = evento.changedTouches[0].clientX - toqueX;
        const desplazamientoY = evento.changedTouches[0].clientY - toqueY;
        if (Math.abs(desplazamientoX) > 45 && Math.abs(desplazamientoX) > Math.abs(desplazamientoY)) {
          actualizar(indice + (desplazamientoX < 0 ? 1 : -1));
        }
        reproducir();
      }, { passive: true });
      document.addEventListener('visibilitychange', () => document.hidden ? detener() : reproducir());

      actualizar(0);
      reproducir();
    });
  }

  function iniciarHistorias() {
    document.querySelectorAll('[data-fr-historia]:not([data-historia-lista])').forEach((historia) => {
      historia.dataset.historiaLista = '1';
      const pestanas = Array.from(historia.querySelectorAll('[data-fr-historia-tab]'));
      const paneles = Array.from(historia.querySelectorAll('[data-fr-historia-panel]'));
      const puntos = Array.from(historia.querySelectorAll('[data-fr-historia-punto]'));
      const anterior = historia.querySelector('[data-fr-historia-anterior]');
      const siguiente = historia.querySelector('[data-fr-historia-siguiente]');
      const consultaMovil = window.matchMedia('(max-width: 750px)');
      let indice = 0;
      let temporizador;
      let toqueX = 0;
      let toqueY = 0;
      const intervaloHistoria = Math.max(3000, Number(historia.dataset.intervalo) || 3000);
      const rotacionAutomatica = historia.dataset.autoplay !== 'false';

      function mostrar(capitulo) {
        indice = Math.max(0, pestanas.findIndex((pestana) => pestana.dataset.frHistoriaTab === capitulo));
        pestanas.forEach((pestana) => {
          const activa = pestana.dataset.frHistoriaTab === capitulo;
          pestana.classList.toggle('es-activa', activa);
          pestana.setAttribute('aria-selected', activa ? 'true' : 'false');
        });
        paneles.forEach((panel) => {
          const activo = panel.dataset.frHistoriaPanel === capitulo;
          panel.hidden = !activo;
          panel.classList.toggle('es-activo', activo);
        });
        puntos.forEach((punto, posicion) => {
          punto.classList.toggle('es-activo', posicion === indice);
          punto.setAttribute('aria-current', posicion === indice ? 'true' : 'false');
        });
      }

      function mover(direccion) {
        indice = (indice + direccion + pestanas.length) % pestanas.length;
        mostrar(pestanas[indice].dataset.frHistoriaTab);
      }

      function detener() {
        if (temporizador) window.clearInterval(temporizador);
      }

      function reproducir() {
        detener();
        if (rotacionAutomatica && consultaMovil.matches && !reducirMovimiento && pestanas.length > 1) {
          temporizador = window.setInterval(() => mover(1), intervaloHistoria);
        }
      }

      pestanas.forEach((pestana) => pestana.addEventListener('click', () => {
        mostrar(pestana.dataset.frHistoriaTab);
        reproducir();
      }));
      puntos.forEach((punto) => punto.addEventListener('click', () => {
        indice = Number(punto.dataset.frHistoriaPunto);
        mostrar(pestanas[indice].dataset.frHistoriaTab);
        reproducir();
      }));
      anterior?.addEventListener('click', () => { mover(-1); reproducir(); });
      siguiente?.addEventListener('click', () => { mover(1); reproducir(); });
      historia.addEventListener('touchstart', (evento) => {
        toqueX = evento.changedTouches[0].clientX;
        toqueY = evento.changedTouches[0].clientY;
        detener();
      }, { passive: true });
      historia.addEventListener('touchend', (evento) => {
        const desplazamientoX = evento.changedTouches[0].clientX - toqueX;
        const desplazamientoY = evento.changedTouches[0].clientY - toqueY;
        if (Math.abs(desplazamientoX) > 45 && Math.abs(desplazamientoX) > Math.abs(desplazamientoY)) {
          mover(desplazamientoX < 0 ? 1 : -1);
        }
        reproducir();
      }, { passive: true });
      historia.addEventListener('mouseenter', detener);
      historia.addEventListener('mouseleave', reproducir);
      historia.addEventListener('focusin', detener);
      historia.addEventListener('focusout', reproducir);
      consultaMovil.addEventListener?.('change', reproducir);
      mostrar(pestanas[0]?.dataset.frHistoriaTab || 'pasado');
      reproducir();
    });
  }

  function iniciarContadores() {
    document.querySelectorAll('[data-fr-contador]:not([data-contador-listo])').forEach((seccion) => {
      seccion.dataset.contadorListo = '1';
      const espera = seccion.querySelector('[data-fr-contador-espera]');
      const builds = seccion.querySelector('[data-fr-builds]');
      const dias = seccion.querySelector('[data-fr-dias]');
      const horas = seccion.querySelector('[data-fr-horas]');
      const minutos = seccion.querySelector('[data-fr-minutos]');
      const segundos = seccion.querySelector('[data-fr-segundos]');
      const fechaObjetivo = new Date(seccion.dataset.fecha).getTime();
      const previsualizar = seccion.dataset.previsualizar === 'true';
      let intervalo;

      function revelar() {
        if (intervalo) window.clearInterval(intervalo);
        if (espera) espera.hidden = true;
        if (builds) {
          builds.hidden = false;
          builds.classList.add('es-revelado');
          builds.querySelectorAll('.fr-aparece').forEach((elemento) => elemento.classList.add('es-visible'));
        }
      }

      function actualizar() {
        const restante = fechaObjetivo - Date.now();
        if (!Number.isFinite(fechaObjetivo) || restante <= 0) {
          revelar();
          return;
        }
        const diasRestantes = Math.floor(restante / 86400000);
        const horasRestantes = Math.floor((restante % 86400000) / 3600000);
        const minutosRestantes = Math.floor((restante % 3600000) / 60000);
        const segundosRestantes = Math.floor((restante % 60000) / 1000);
        if (dias) dias.textContent = String(diasRestantes).padStart(3, '0');
        if (horas) horas.textContent = String(horasRestantes).padStart(2, '0');
        if (minutos) minutos.textContent = String(minutosRestantes).padStart(2, '0');
        if (segundos) segundos.textContent = String(segundosRestantes).padStart(2, '0');
      }

      if (previsualizar) {
        revelar();
        return;
      }
      actualizar();
      intervalo = window.setInterval(actualizar, 1000);
    });
  }

  function iniciarVistasGpu() {
    document.querySelectorAll('[data-fr-gpu]:not([data-gpu-lista])').forEach((seccion) => {
      seccion.dataset.gpuLista = '1';
      const pestanas = Array.from(seccion.querySelectorAll('[data-fr-gpu-tab]'));
      const paneles = Array.from(seccion.querySelectorAll('[data-fr-gpu-panel]'));
      if (!pestanas.length || !paneles.length) return;

      function mostrar(vista) {
        pestanas.forEach((pestana) => {
          const activa = pestana.dataset.frGpuTab === vista;
          pestana.classList.toggle('es-activa', activa);
          pestana.setAttribute('aria-selected', activa ? 'true' : 'false');
          pestana.tabIndex = activa ? 0 : -1;
        });
        paneles.forEach((panel) => {
          const activo = panel.dataset.frGpuPanel === vista;
          panel.hidden = !activo;
          panel.classList.toggle('es-activo', activo);
        });
      }

      pestanas.forEach((pestana, indice) => {
        pestana.addEventListener('click', () => mostrar(pestana.dataset.frGpuTab));
        pestana.addEventListener('keydown', (evento) => {
          if (evento.key !== 'ArrowLeft' && evento.key !== 'ArrowRight') return;
          evento.preventDefault();
          const direccion = evento.key === 'ArrowRight' ? 1 : -1;
          const siguiente = pestanas[(indice + direccion + pestanas.length) % pestanas.length];
          mostrar(siguiente.dataset.frGpuTab);
          siguiente.focus();
        });
      });
      mostrar(pestanas[0].dataset.frGpuTab);
    });
  }

  function iniciar() {
    iniciarApariciones();
    iniciarParallax();
    iniciarRuedas();
    iniciarHistorias();
    iniciarContadores();
    iniciarVistasGpu();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
